import {useParams} from "react-router-dom";
import Countback from "../../components/countback";
import moment from "moment";
import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import Loading from "../../components/loading";
import {useSelector} from "react-redux";
import CasinoListItem from "../casino-group/item";
import {useTranslation} from "react-i18next";
import Leaderboard from "../tournaments/leaderboard";

const TournamentDetail = () => {
    const {activeLanguage} = useSelector(state => state.globalReducer)

    const {t} = useTranslation()
    let {uuid} = useParams()

    const [loading, setLoading] = useState(true)
    const [tournament, setTournament] = useState({})


    useEffect(() => {
        if (uuid && activeLanguage?.key)
            associateServices.showTournament({
                uuid,
                language: activeLanguage?.key
            }).then(res => {
                setTournament(res?.data)
                setLoading(false)
            })
    }, [uuid, activeLanguage?.key])
    return (

        loading ?
            <div className="section section--first">
                <Loading/>
            </div>
            :
            <>
                <div className="section section--first">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="section__title section__title--head">
                                    {tournament.title}
                                </h1>
                            </div>
                            <div className="col-12 col-xxl-7">
                                <div className="content">
                                    <div className="content__main content__main--big">
                                        <div className="tournament__cover">
                                            {/*<span className="tournament__status tournament__status--passing">*/}
                                            {/*  Passing*/}
                                            {/*</span>*/}
                                            <div className="tournament__prize">
                                                <span>{t('tournaments.total-reward')}</span>
                                                <p>${tournament.prize}</p>
                                            </div>
                                            <img
                                                src={tournament.image}
                                                alt=""/>
                                        </div>

                                        <Countback showDesc={false} showTitle={false}
                                                   nextDate={tournament.end}/>


                                        <div className="article">
                                            <div dangerouslySetInnerHTML={{__html: tournament.content}}/>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-xxl-5">
                                <div className="content" id="tournament-leaderboard">
                                    <div className="content__main content__main--big">
                                        <div className="table-responsive w-100">
                                            <Leaderboard uuid={tournament.uuid}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="section__title-wrap">
                                    <h2 className="section__title">{t('tournaments.games')}</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">

                            {
                                tournament?.games?.map((game, i) => <CasinoListItem
                                    passive={loading}
                                    key={i}
                                    index={i}
                                    game={game}
                                />)
                            }

                        </div>
                    </div>
                </div>
            </>

    )
}


export default TournamentDetail
